export var ENTITY = "chat";
export var REDUCER_KEY = "CHATS_V2";
export var BASE_PATH_ENTITY = "chats";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
